/* ==========================================================================
   Chatknop — twee taken.

   1. Uit beeld zodra de footer in zicht komt. De knop staat vast rechtsonder;
      in de footer zitten daar het nieuwsbriefveld en de knoppen, en op een
      telefoon legde de chatknop zich precies over de verzendknop heen. In de
      footer staan de contactgegevens toch al.

   2. Onze knop in plaats van die van Shopify Inbox. Inbox zet zijn eigen
      ronde knop in dezelfde hoek, dus er stonden er twee.

      Waarom het op deze manier gaat: de knop van Inbox zit in een iframe van
      shopify.com. Cross-origin, dus we kunnen er niet in kijken en er ook geen
      klik in afvuren. Wat we wél kunnen: dat iframe onzichtbaar maken en onze
      eigen knop er precies overheen leggen, met `pointer-events: none` erop.
      De klik gaat dan door onze knop heen naar het onzichtbare iframe
      eronder. Zo bedient de bezoeker Inbox, maar ziet hij onze knop.

      Het chatvenster zelf blijft van Inbox. Dat is de bedoeling: dat venster
      is de chat.

      Alles hieronder is voorwaardelijk. Vindt dit script geen Inbox-widget,
      dan gebeurt er niets en blijft onze knop een gewone link naar de pagina
      die in de theme editor staat. Zonder Inbox verandert er dus niets, en
      als Inbox ooit verdwijnt, valt het vanzelf terug.
   ========================================================================== */

(() => {
  const knop = document.querySelector('[data-flux-chat]');
  if (!knop) return;

  /* ---------------------------------------------- 1. wegschuiven bij de footer */
  const footer = document.querySelector('.flux-footer, .shopify-section-group-footer-group footer, footer');
  if (footer && 'IntersectionObserver' in window) {
    new IntersectionObserver(
      ([regel]) => knop.toggleAttribute('data-weg', regel.isIntersecting),
      // Pas als de footer echt in beeld komt, niet al bij de eerste pixel.
      { rootMargin: '0px 0px -25% 0px' }
    ).observe(footer);
  }

  /* ---------------------------------------------- 2. koppelen aan Shopify Inbox */
  if (knop.dataset.inbox !== 'aan') return;

  // Inbox heeft door de jaren meer dan één opzet gehad; dit dekt ze allemaal.
  // Het gaat om het kleine ronde knopje, niet om het chatvenster.
  const KIEZERS = [
    '#ShopifyChat',
    '#shopify-chat',
    '[id^="shopify-chat"]',
    'iframe#chat-button-iframe',
    'iframe[id*="chat-button"]',
    'iframe[title*="chat" i]',
    'iframe[name*="chat" i]',
  ];

  // Boven deze maat is het geen knopje meer maar een geopend venster. Dan
  // laten we het met rust: het venster moet gewoon zichtbaar zijn.
  const KNOP_MAX = 140;

  const zoekWidget = () => {
    for (const kiezer of KIEZERS) {
      for (const el of document.querySelectorAll(kiezer)) {
        if (el.closest('[data-flux-chat]')) continue;
        const r = el.getBoundingClientRect();
        if (r.width > 0 && r.height > 0) return el;
      }
    }
    return null;
  };

  let widget = null;
  let gekoppeld = false;

  /* Onze knop over het onzichtbare knopje van Inbox leggen. We verplaatsen dat
     knopje niet: waar Inbox zijn knop neerzet, is zijn keuze, en meeverhuizen
     is minder breekbaar dan tegenwerken. */
  const uitlijnen = () => {
    if (!widget) return;
    const r = widget.getBoundingClientRect();

    // Uitgeklapt venster: knopje loslaten, onze knop even weg.
    if (r.width > KNOP_MAX || r.height > KNOP_MAX) {
      widget.style.opacity = '';
      knop.style.visibility = 'hidden';
      return;
    }

    widget.style.opacity = '0';
    knop.style.visibility = '';
    knop.style.insetInlineStart = `${Math.round(r.left)}px`;
    knop.style.insetInlineEnd = 'auto';
    knop.style.top = `${Math.round(r.top)}px`;
    knop.style.bottom = 'auto';
  };

  const koppelen = (el) => {
    widget = el;
    gekoppeld = true;
    knop.dataset.inboxGekoppeld = 'ja';
    // De klik moet bij Inbox uitkomen, niet bij onze link.
    knop.style.pointerEvents = 'none';
    knop.setAttribute('aria-hidden', 'true');
    knop.setAttribute('tabindex', '-1');
    uitlijnen();
    if ('ResizeObserver' in window) new ResizeObserver(uitlijnen).observe(widget);
    addEventListener('resize', uitlijnen, { passive: true });
    addEventListener('scroll', uitlijnen, { passive: true });
  };

  /* Inbox laadt na ons. We kijken een tijdje mee en stoppen daarna: blijven
     zoeken kost alleen maar. Vindt hij niets, dan blijft onze knop een link. */
  const start = Date.now();
  const kijken = new MutationObserver(() => {
    if (gekoppeld) return;
    const el = zoekWidget();
    if (el) {
      koppelen(el);
      kijken.disconnect();
    } else if (Date.now() - start > 20000) {
      kijken.disconnect();
    }
  });
  kijken.observe(document.body, { childList: true, subtree: true });

  const nu = zoekWidget();
  if (nu) {
    koppelen(nu);
    kijken.disconnect();
  }
})();
